import { combineReducers } from "redux";
import modal from "./modal";
import user from "./user";
import gameSession from "./gameSession";

const rootReducer = combineReducers({ modal, user, gameSession });

export default rootReducer;
